import { type ResolvedGlobalPageSettings } from '~/lib/ContentfulGraphqlService';

export default function isOneOfAccountAreaPages(
  $globalPageSettings: Ref<ResolvedGlobalPageSettings | null>,
  slug: Ref<string>
) {
  const shopConfig = $globalPageSettings.value?.shopConfig;
  return [
    shopConfig?.customerAccountAddressesPage?.slug,
    shopConfig?.customerAccountOrdersPage?.slug,
    shopConfig?.customerAccountOverviewPage?.slug,
    shopConfig?.customerAccountProfilePage?.slug,
    shopConfig?.customerAccountRequestsPage?.slug
  ].includes(slug.value);
}
